// import padrao from '../profile.png'

import axios from 'axios'
import { useEffect, useState } from 'react'
import * as TypIcons from 'react-icons/ti'
import { useNavigate } from 'react-router-dom'
import validator from 'validator'
import '../../styles/pages/SubMenuPages/SubMenuEmpresas/ModalSubMenuEmpresas/AlterarRegistroEmpresas.css'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage8
} from '../Main'
//import ProfileDireita from '../ProfileDireita'
import { NavDireita } from '../SideBar-right/SideBarDireita'
import SidebarMobile from '../SideBar-right/SidebarMobile'
import authService from './auth.service'
//const uuidv4 = require('uuid/v4')
//const { v4: uuidv4 } = require('uuid');

function VerPerfil() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);

  const history = useNavigate()
  var user = authService.getCurrentUser()
  var modalInfo = user[0]
  const [funcoes, setFuncao] = useState([])
  const [grupos, setGrupo] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [errorPass, setErrorPass] = useState(false)
  const [imagens, setImagens] = useState({
    NomeImagem: '',
    Imagem: ''
  })
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/funcao/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setFuncao(response.data)
      })
  })
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/grupoUsuario/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setGrupo(response.data)
      })
  })
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdPessoa: modalInfo.IdPessoa,
    IdEmpresa: modalInfo.IdEmpresa,
    IdFuncao: modalInfo.IdFuncao,
    IdGrupoUsuario: modalInfo.IdGrupoUsuario,
    pesNome: modalInfo.pesNome,
    pesFoto: modalInfo.pesFoto,
    pesEmail: modalInfo.pesEmail,
    pesSenha: '',
    confPesSenha: '',
    pesTelefone: modalInfo.pesTelefone,
    pesCelular: modalInfo.pesCelular,
    pesEndereco: modalInfo.pesEndereco,
    pesAcessoWeb: modalInfo.pesAcessoWeb,
    pesAcessoApp: modalInfo.pesAcessoApp,
    pesIdioma: modalInfo.pesIdioma,
    pesStatus: modalInfo.pesStatus,
    pesObservacoes: modalInfo.pesObservacoes,
    pesAlteradoPor: user[0].pesEmail,
    pesAlteradoEm: newDate
  })

  function handleInputChange(event) {
    if (
      event.target.name === 'pesAcessoWeb' ||
      event.target.name === 'pesAcessoApp' ||
      event.target.name === 'pesStatus'
    ) {
      if (event.target.value === 'on') {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      if (event.target.name === 'pesSenha') {
        if (
          validator.isStrongPassword(event.target.value, {
            minLength: 7,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
          })
        ) {
          setErrorMessage('')
          setErrorPass(false)
          if (event.target.value !== campos.confPesSenha) {
            setErrorPass(true)
            setErrorMessage('A confirmação da senha está incorreta')
          } else {
            setErrorMessage('')
            setErrorPass(false)
          }
        } else {
          setErrorPass(true)
          setErrorMessage(
            'A senha não é segura o bastante, a senha deve conter 1 caracter especial, uma letra maiúscula e um número!'
          )
        }
      }
      if (event.target.name === 'confPesSenha') {
        if (event.target.value !== campos.pesSenha) {
          setErrorPass(true)
          setErrorMessage('A confirmação da senha está incorreta')
        } else {
          setErrorMessage('')
          setErrorPass(false)
        }
      }
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  const [image, setImage] = useState(modalInfo.pesFoto)
  function handleFormSubmit(event) {
    event.preventDefault()
    const formData = new FormData()
    formData.append('file', image)
    var reader = new FileReader()
    if (image) {
      reader.readAsDataURL(image)
      reader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result
        imagens['Imagem'] = srcData.split(',')[1]
        imagens['NomeImagem'] = uuidv4
        setImagens(imagens)
      }
      axios
        .post(process.env.REACT_APP_API_URL + '/upload', imagens)
        .then(response => {
          campos['pesFoto'] = response.data['url']
          console.log(imagens)
          console.log(response.data)
          setCampos(campos)
        })
    }
    axios
      .put(
        process.env.REACT_APP_API_URL + '/api/v1/pessoa/' + campos.IdPessoa,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <button
          className="btnReturn"
          type="button"
          onClick={() => history(-1)}
        >
          <TypIcons.TiArrowBackOutline />
        </button>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>Informações do Usuário:</TitlePage1>
            <TitlePage2>{user[0].pesNome}</TitlePage2>
            <TitlePage8>{campos.pesObservacoes}</TitlePage8>
          </TitleOfPage>
        </div>
        <form className="tabelaPadraoViewProfile" onSubmit={handleFormSubmit}>
          <div className="div-group">
            {image ? (
              <img
                src={campos.pesFoto}
                alt="Profile"
                className="imgProfile1"
                width="150"
                height="150"
              />
            ) : (
              <img src="./perfil.png" alt="Profile" className="imgProfile1" />
            )}
            <input
              type="file"
              name="pesFoto"
              className="form-control-file-1"
              id="pesFoto"
              accept=".gif,.jpg,.jpeg,.png"
              onChange={function (event) {
                setImage(event.target[0])
                console.log(event)
                console.log(event.target)
              }}
            />
          </div>
          <div className="formCadModal">
            <input
              className="fcadastroPessoa1-viewProfile"
              placeholder="Nome"
              type="text"
              required
              id="fname"
              defaultValue={campos.pesNome}
              name="pesNome"
              onChange={handleInputChange}
            />

            <select
              disabled
              name="IdFuncao"
              className="fcadastroPessoa2-viewProfile"
              typeof="text"
              required
              defaultValue={campos.IdFuncao.toString()}
              id="fcontexto"
              onChange={handleInputChange}
            >
              <option value="0">Selecione uma Função</option>
              {funcoes.map(funcao => (
                <option
                  value={funcao.IdFuncao}
                  selected={funcao.IdFuncao === campos.IdFuncao}
                >
                  {funcao.fncDescricao}
                </option>
              ))}
            </select>

            <select
              name="pesIdioma"
              className="fcadastroPessoa4-viewProfile"
              typeof="text"
              required
              defaultValue={campos.pesIdioma}
              id="fcontexto"
              onChange={handleInputChange}
            >
              <option value="">Selecione o Idioma</option>
              <option value="PORTUGUES">Português</option>
              <option value="INGLES">Inglês</option>
              <option value="ESPANHOL">Espanhol</option>
            </select>

            <input
              disabled
              className="fcadastroPessoa5-viewProfile"
              placeholder="E-Mail"
              type="text"
              required
              defaultValue={campos.pesEmail}
              id="mail"
              name="pesEmail"
              onChange={handleInputChange}
            />
            <input
              disabled
              className="fcadastroPessoa6-viewProfile"
              placeholder="Telefone"
              type="text"
              defaultValue={campos.pesTelefone}
              id="fname"
              name="pesTelefone"
              onChange={handleInputChange}
            />
            <input
              disabled
              className="fcadastroPessoa7-viewProfile"
              placeholder="Celular"
              type="text"
              defaultValue={campos.pesCelular}
              id="fname"
              name="pesCelular"
              onChange={handleInputChange}
            />
            <input
              hidden
              className="fcadastroPessoa8-viewProfile"
              placeholder="Endereço"
              type="text"
              defaultValue={campos.pesEndereco}
              id="fname"
              name="pesEndereco"
              onChange={handleInputChange}
            />

            <input
              className="fcadastroPessoa9-viewProfile"
              placeholder="Senha"
              type="password"
              id="fname"
              name="pesSenha"
              onChange={handleInputChange}
            />
            <input
              className="fcadastroPessoa10-viewProfile"
              placeholder="Confirmar Senha"
              type="password"
              id="fname"
              name="confPesSenha"
              onChange={handleInputChange}
            />
            {errorPass === true ? <span>{errorMessage}</span> : <div></div>}
            <select
              disabled
              name="IdGrupoUsuario"
              className="fcadastroPessoa11-viewProfile"
              typeof="text"
              required
              defaultValue={campos.IdGrupoUsuario}
              id="fcontexto"
              onChange={handleInputChange}
            >
              <option value="0">Selecione um grupo</option>
              {grupos.map(grupo => (
                <option
                  value={grupo.IdGrupoUsuario}
                  selected={grupo.IdGrupoUsuario === campos.IdGrupoUsuario}
                >
                  {grupo.gruDescricao}
                </option>
              ))}
            </select>
          </div>

          <button type="submit" className="gravar-modal" disabled={errorPass}>
            Salvar Registro
          </button>
        </form>
      </ContainerPage>
      <nav className="esconderFiltro">
        <div className="cxProfile">
          <h6 className="titleProfile1"> Seja Muito Bem-vindo,</h6>
          <h6 className="titleProfile2">{user[0].pesNome}</h6>
          <div className="alignFotoProfile">
            {image ? (
              <img className="logo1" src={image} alt="perfil" />
            ) : (
              <img src="./perfil.png" alt="Profile" className="logo1" />
            )}
          </div>
        </div>
        <NavDireita />
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}
export default VerPerfil
